<p-dialog
    data-testid="activity-dialog"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onHide(); close()"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '550px' }"
    (onShow)="onShow()"
>
    <ng-template pTemplate="header">
        <div>
            <span class="p-dialog-title">{{ dialogHeader }}</span>
            @if (isLocked && !userCanOverrideLock) {
                <i [pTooltip]="'activities_locked_info' | translate" tooltipPosition="bottom" tooltipStyleClass="nowrap-tooltip" class="pi pi-lock ml-2"></i>
            }
        </div>
    </ng-template>

    <ng-template pTemplate="content" class="mt-2">
        @if (!isLoading) {
            <div class="add-activity-dialog-content-area">
                <div [tooltipDisabled]="isPro" pTooltip="{{ 'activities_userselect_pro' | translate }}" tooltipPosition="top">
                    @if (currentUser?.hasPermissionStr("ACTIVITY_READ_TEAM")) {
                        <p-select
                            [options]="usersFilter"
                            [(ngModel)]="selectedUserFilter"
                            placeholder="Users"
                            [filter]="true"
                            (ngModelChange)="onChangeHook($event, 'user')"
                            optionLabel="name"
                            [disabled]="userFilterIsDisabled || disabledEditing"
                            class="w-full mb-4"
                        />
                    }
                </div>

                <p-select
                    data-testid="activity-dialog-layer-1"
                    [disabled]="!selectedUserFilter || disabledEditing"
                    [options]="layer1Filter"
                    [filter]="true"
                    [ngModel]="selectedLayer1Filter"
                    (ngModelChange)="onChangeHook($event, 'tile', 0)"
                    placeholder="{{ getLayerPlaceholder(1) }}"
                    optionLabel="name"
                    class="w-full mb-4"
                >
                    <ng-template pTemplate="selectedItem">
                        @if (selectedLayer1Filter) {
                            <div class="usersFilter-item flex">
                                <div class="layer-select" [style]="'background-color:' + selectedLayer1Filter.color"></div>
                                <div>{{ selectedLayer1Filter.name }}</div>
                            </div>
                        }
                    </ng-template>

                    <ng-template let-layer1Filter pTemplate="item">
                        <div class="usersFilter-item flex">
                            <div class="layer-select" [style]="'background-color:' + layer1Filter.color"></div>
                            <div>{{ layer1Filter.name }}</div>
                        </div>
                    </ng-template>
                </p-select>
                @if (layers[1]?.visible === true && selectedLayer1Filter && layer2Filter.length > 0) {
                    <p-select
                        data-testid="activity-dialog-layer-2"
                        [options]="layer2Filter"
                        [ngModel]="selectedLayer2Filter"
                        (ngModelChange)="onChangeHook($event, 'tile', 1)"
                        placeholder="{{ getLayerPlaceholder(2) }}"
                        [filter]="true"
                        optionLabel="name"
                        optionDisabled="false"
                        class="w-full mb-4"
                        [disabled]="disabledEditing"
                    >
                        <ng-template pTemplate="selectedItem">
                            @if (selectedLayer2Filter) {
                                <div class="usersFilter-item flex">
                                    <div class="layer-select" [style]="'background-color:' + selectedLayer2Filter.color"></div>
                                    <div>{{ selectedLayer2Filter.name }}</div>
                                </div>
                            }
                        </ng-template>

                        <ng-template let-layer2Filter pTemplate="item">
                            <div class="usersFilter-item flex">
                                <div class="layer-select" [style]="'background-color:' + layer2Filter.color"></div>
                                <div>{{ layer2Filter.name }}</div>
                            </div>
                        </ng-template>
                    </p-select>
                }
                @if (layers[2]?.visible === true && selectedLayer2Filter && layer3Filter.length > 0) {
                    <p-select
                        data-testid="activity-dialog-layer-3"
                        [options]="layer3Filter"
                        [ngModel]="selectedLayer3Filter"
                        (ngModelChange)="onChangeHook($event, 'tile', 2)"
                        placeholder="{{ getLayerPlaceholder(3) }}"
                        [filter]="true"
                        optionLabel="name"
                        class="w-full mb-4"
                        [disabled]="disabledEditing"
                    >
                        <ng-template pTemplate="selectedItem">
                            @if (selectedLayer3Filter) {
                                <div class="usersFilter-item flex">
                                    <div class="layer-select" [style]="'background-color:' + selectedLayer3Filter.color"></div>
                                    <div>{{ selectedLayer3Filter.name }}</div>
                                </div>
                            }
                        </ng-template>

                        <ng-template let-layer3Filter pTemplate="item">
                            <div class="usersFilter-item flex">
                                <div class="layer-select" [style]="'background-color:' + layer3Filter.color"></div>
                                <div>{{ layer3Filter.name }}</div>
                            </div>
                        </ng-template>
                    </p-select>
                }

                <textarea
                    data-testid="activity-dialog-note"
                    [(ngModel)]="note"
                    placeholder="{{ 'activities_note' | translate }}"
                    [rows]="3"
                    pTextarea
                    class="mt-6"
                    maxlength="1024"
                    [disabled]="disabledEditing"
                ></textarea>

                <div
                    [ngClass]="currentUser?.hasPermissionStr('ACTIVITY_READ_TEAM') ? 'justify-content-around' : 'justify-content-start'"
                    class="row controls-grid mt-6 gap-[1em]!"
                >
                    @if (userDateFormat) {
                        <!-- when userDateFormat is not yet initialized, it breaks the p-datepicker causing errors -->
                        <p-datePicker
                            data-testid="activity-dialog-from"
                            class="from datepicker-default-width"
                            [(ngModel)]="dateFrom"
                            [showTime]="true"
                            [dateFormat]="userDateFormat"
                            [hourFormat]="userHourFormat"
                            (onBlur)="onChangeHook($event, 'dateFrom')"
                            (ngModelChange)="validateOnDateChange($event, 'dateFrom')"
                            [firstDayOfWeek]="firstDayOfWeek"
                            [disabled]="disabledEditing"
                        />
                        <label class="between">{{ "activities_to" | translate }}</label>
                        <p-datePicker
                            data-testid="activity-dialog-to"
                            class="to datepicker-default-width"
                            [(ngModel)]="dateTo"
                            [showTime]="true"
                            [dateFormat]="userDateFormat"
                            [hourFormat]="userHourFormat"
                            (onBlur)="onChangeHook($event, 'dateTo')"
                            (ngModelChange)="validateOnDateChange($event, 'dateTo')"
                            [firstDayOfWeek]="firstDayOfWeek"
                            [disabled]="disabledEditing"
                        />
                    }
                    @if (currentUser?.hasPermissionStr("ACTIVITY_READ_TEAM")) {
                        <div pTooltip="{{ (!isPro ? 'tooltip_billed_button' : '') | translate }}">
                            <p-checkbox
                                data-testid="activity-dialog-billed"
                                class="opt"
                                [binary]="true"
                                [disabled]="!isPro || disabledEditing"
                                [(ngModel)]="isBilled"
                                (ngModelChange)="onChangeHook($event, 'billed')"
                            />
                            <label class="ml-2" for="size_normal">{{ "activities_billed" | translate }}</label>
                        </div>
                    }

                    <!-- helper texts only under calendars -->
                    <small class="from-help">{{ fromOffset }}</small>
                    <small class="to-help">{{ toOffset }}</small>
                </div>

                @if (timeZoneSwitchText) {
                    <div class="activity-info-text">{{ timeZoneSwitchText }}</div>
                }

                @if (durationWarningText) {
                    <div data-testid="activity-dialog-duration-warning" class="activity-warn-text">{{ durationWarningText }}</div>
                }
            </div>
        }

        @if (isLoading) {
            <div class="loading-spinner">
                <p-progressSpinner></p-progressSpinner>
            </div>
        }
    </ng-template>

    <ng-template pTemplate="footer" class="mt-2">
        @if (!isLoading && !disabledEditing) {
            <div class="flex justify-between w-full">
                <div>
                    @if (!isNewActivityMode) {
                        <button
                            data-testid="activity-dialog-delete"
                            type="button"
                            pButton
                            severity="danger"
                            (click)="confirmDeleteActivity()"
                            class="p-button-text"
                            iconPos="left"
                        >
                            <i class="pi pi-trash"></i>
                            {{ "button_delete" | translate }}
                        </button>
                    }
                </div>
                <div>
                    <button data-testid="activity-dialog-cancel" type="button" pButton severity="secondary" (click)="close()" class="p-button-text mr-2">
                        {{ "button_cancel" | translate }}
                    </button>
                    <p-button data-testid="activity-dialog-save" [disabled]="saveDisabled" (onClick)="save()">{{ primaryButtonText }}</p-button>
                </div>
            </div>
        }
        @if (disabledEditing) {
            <div class="flex justify-between w-full">
                <div>&nbsp;</div>
                <div>
                    <p-button iconPos="left" (onClick)="close()"> {{ primaryButtonText }}</p-button>
                </div>
            </div>
        }
    </ng-template>
</p-dialog>
